import { useMemo, ReactElement } from "react";

import Stack from "@mui/material/Stack";

import { IconQuestion, IconExclamation } from "components/atoms/Icon";
import { DaySummary } from "models/travelExpense";

export interface ApplicationStatusProps {
  daySummary: DaySummary;
}

export function ApplicationStatus({
  daySummary,
}: ApplicationStatusProps): ReactElement | null {
  const icon = useMemo(() => {
    const { applicationStatus, commutingExpenses, transportationExpenses } =
      daySummary;

    if (applicationStatus === "未申請") return <IconQuestion />;

    if (commutingExpenses.find(({ modifiedBy }) => modifiedBy === "user")) {
      return <IconExclamation />;
    }
    if (
      transportationExpenses.find(({ modifiedBy }) => modifiedBy === "user")
    ) {
      return <IconExclamation />;
    }
    return null;
  }, [daySummary]);

  return (
    <Stack>
      {daySummary.applicationStatus === "未登録" ? (
        <a href="/routes">{daySummary.applicationStatus}</a>
      ) : (
        <span>{daySummary.applicationStatus}</span>
      )}
      {icon}
    </Stack>
  );
}
